import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// Define a service using a base URL and expected endpoints
export const packingApi = baseApi.injectEndpoints({
  reducerPath: "packingApi",
  endpoints: (builder) => ({
    addPacking: builder.mutation({
      query: (user) => {
        return {
          url: "packing-type",
          method: "POST",
          body: user,
          headers: {
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["packing"],
    }),
    updatePacking: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `packing-type/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["packing"],
    }),
    deletePacking: builder.mutation({
      query: (id) => {
        return {
          url: `packing-type/${id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["packing"],
    }),
    getAllPacking: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `packing-type?${queryParams}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          //   authorization: `Bearer ${getToken()}`,
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["packing"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddPackingMutation,
  useUpdatePackingMutation,
  useDeletePackingMutation,
  useGetAllPackingQuery, // Add this line to import the query hook
} = packingApi;
